import { getLanguages } from 'constants/general.constants'

export const LOCALES: Record<string, string> = Object.entries(getLanguages()).reduce(
  (acc, [key, val]) => ({ ...acc, [key]: val.value }),
  {}
)

export const LOCALES_LIST = Object.values(LOCALES)
